import PrismicPage from "~/views/PrismicPage";

function Page(props) {
  return <PrismicPage {...props} />;
}

Page.getInitialProps = async (ctx) => {
  const props = await PrismicPage.getInitialProps(ctx);
  return props;
};

export default Page;
